import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, apiErrorMessage, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        setToken(null);
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(
    () => ({
      user,
      loading,
      async login(email, password) {
        const res = await api.post("/auth/login", { email, password });
        setToken(res.data.token);
        setUser(res.data.user);
        return res.data.user;
      },
      async register(payload) {
        const res = await api.post("/auth/register", payload);
        setToken(res.data.token);
        setUser(res.data.user);
        return res.data.user;
      },
      logout() {
        setToken(null);
        setUser(null);
      },
      refreshUser: async () => {
        const res = await api.get("/auth/me");
        setUser(res.data);
        return res.data;
      },
    }),
    [user, loading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}

export { apiErrorMessage };
